// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__Ufr8v","label":"counter_label__86GnG","icon":"counter_icon__NAR1P","values":"counter_values__zl9wc"};